<template>
  <!-- 全局侧边导航栏、顶部栏组件 -->
  <div class="container" v-if="rightFilter.includes($route.name) || hasRight">
    <template v-if="!layoutFilter.includes($route.name)">
      <div class="container-header">
        <div class="container-header-left">
          <!-- 后期添加logo -->
          <div class="container-header-box">
            <img v-if="g_imgSrc.logo" alt :src="g_imgSrc.logo" class="container-header-logo" />
          </div>
          <p class="container-header-name">腾讯智慧医药管理平台</p>
        </div>
        <div class="container-header-right" @click="toggleOpen">
          <div class="container-header-menu">
            <div class="container-header-username">
              {{ username }}
            </div>
            <img
              alt
              :class="{ 'container-header-icon': true, normal: menuOpen }"
              :src="g_imgSrc.bottomArrow"
            />
            <div v-show="menuOpen" class="container-header-outMenu">
              <div class="outMenu-item" @click="g_tourl('/saas/help.html')">帮助</div>
              <div class="outMenu-item" @click="exit">退出</div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-body">
        <div v-show="!($route.name === 'register')" class="container-aside">
          <side-menu></side-menu>
        </div>
        <main>
          <el-breadcrumb
            class="breadcrumb"
            separator-class="el-icon-arrow-right"
            v-if="breadcrumb && breadcrumb.length > 1"
          >
            <el-breadcrumb-item
              v-for="item in breadcrumb"
              :key="item.menu_name"
              :to="item.menu_path ? { name: item.menu_path, query: item.menu_params || {} } : ''"
              :replace="true"
            >
              {{ item.menu_name }}
            </el-breadcrumb-item>
          </el-breadcrumb>
          <slot />
        </main>
      </div>
    </template>
    <main v-else>
      <slot />
    </main>
  </div>
</template>
<script>
import sideMenu from './side-menu.vue';
import config from '@/config';
import { mapGetters, mapActions, mapState } from 'vuex';
import login from '@/utils/login';
import takeRight from 'lodash/takeRight';
export default {
  name: 'Layout',
  components: {
    sideMenu,
  },
  data() {
    return {
      menuOpen: false, // 控制退出按钮展示
      layoutFilter: config.layoutFilter,
      rightFilter: config.rightFilter,
    };
  },
  computed: {
    ...mapGetters('user', {
      username: 'getName',
      breadcrumb: 'getBreadcrumb',
    }),
    ...mapState('user', {
      hasRight: 'hasRight',
    }),
  },
  created() {
    this.setDomain();
    this.getManagerLogin();
  },
  mounted() {},
  methods: {
    ...mapActions('user', ['getManagerLogin']),
    exit() {
      login.exit();
    },
    toggleOpen() {
      this.menuOpen = !this.menuOpen;
    },
    setDomain() {
      const { hostname } = location;
      if (hostname.includes('localhost')) {
        return;
      }
      const rootDomain = takeRight(hostname.split('.'), 2).join('.');
      console.log('rootDomain', rootDomain);
      document.domain = rootDomain;
    },
  },
};
</script>
<style lang="scss" scoped>
body {
  height: 100%;
  width: 100%;
}
.container {
  min-width: 1440px;
  height: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  .container-header {
    height: 88px;
    width: 100%;
    background: #ffffff;
    padding: 0 24px 0 32px;
    box-sizing: border-box;
    color: rgba(0, 0, 0, 0.85);
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    .container-header-left {
      height: 100%;
      float: left;
      .container-header-box {
        float: left;
        width: 28px;
        height: 100%;
        /* display: inline-block; */
        line-height: 88px;
        position: relative;
        .container-header-logo {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 28px;
          height: 28px;
        }
      }
      .container-header-name {
        float: left;
        /* display: inline-block; */
        color: rgba(0, 0, 0, 0.85);
        font-size: 20px;
        height: 100%;
        line-height: 88px;
        font-weight: bold;
        margin-left: 16px;
        float: right;
      }
    }
    .container-header-right {
      height: 100%;
      line-height: 88px;
      font-size: 16px;
      float: right;
      .container-header-menu {
        cursor: pointer;
        display: inline-block;
        position: relative;
        color: rgba(0, 0, 0, 0.85);
        .container-header-username {
          display: inline-block;
          /* 防止多次点击选中文字 */
        }
        .container-header-icon {
          height: 8px;
          width: 16px;
          margin-bottom: 1px;
          margin-left: 8px;
        }
        .normal {
          transform: rotate(0deg);
          -webkit-transform: rotate(0deg);
          transition: transform 0.5s;
        }
        .inverse {
          transform: rotate(180deg);
          -webkit-transform: rotate(180deg);
          transition: transform 0.5s;
        }
        .container-header-outMenu {
          z-index: 10;
          font-family: PingFangSC-Regular;
          position: absolute;
          right: 0px;
          top: 54px;
          height: 113px;
          width: 150px;
          text-align: center;
          background-color: #ffffff;
          border: 1px solid #dcdfe6;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
          padding: 20px 0 8px;
          border-radius: 8px;
          .iconSize {
            position: absolute;
            left: 103px;
            width: 19px;
            top: -11px;
            height: 12px;
          }
          .outMenu-item {
            width: 100%;
            height: 40px;
            line-height: 40px;
            color: #303133;
            padding-left: 24px;
            text-align: left;
          }
          .outMenu-item:hover {
            background: #f5f7fa;
          }
        }
      }
    }
  }
  .container-body {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    .container-aside {
      min-width: 248px;
      height: 100%;
      border-right: 1px solid rgba(0, 0, 0, 0.08);
      font-weight: bold;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 0;
      }
    }
    main {
      height: 100%;
      flex: 1;
      overflow: auto;
      padding: 24px;
      box-sizing: border-box;
      .breadcrumb {
        margin-bottom: 24px;
      }
    }
  }
}
</style>
